<template>
  <div>
    <el-button type="primary" @click="openSee">
      <slot></slot>
    </el-button>

    <el-drawer
        title="生产条码"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-form :inline="true">
          <el-form-item label="存货编码">
            <el-input v-model="form.product_code" placeholder="请输入存货编码"></el-input>
          </el-form-item>
          <el-form-item label="生产数量">
            <el-input v-model="form.build_num" placeholder="请输入生产数量"></el-input>
          </el-form-item>
          <el-form-item label="每箱数量">
            <el-input v-model="form.box_size" placeholder="请输入每箱数量"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-loading="submitIng" @click="toSubmit">生成</el-button>
            <a style="margin-left: 10px;" v-if="barCodeList.length > 0" target="_blank" :href="excelUrl">
              <el-button  type="primary">下载</el-button>
            </a>
          </el-form-item>
        </el-form>
        <div v-if="boxCodeList.length > 0">
          <h2>箱码信息</h2>
          <div>{{boxCodeList}}</div>
        </div>
        <div v-if="barCodeList.length > 0">
          <h2>条码信息</h2>
          <div>{{barCodeList}}</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      openStatus: false,
      form: {
        product_code: '',
        build_num: '',
        box_size: '',
      },
      submitIng: false,
      barCodeList: [],
      boxCodeList: [],
      excelUrl: '',
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {},
  mounted() {
  },
  methods: {
    openSee() {
      const _this = this;
      _this.form = {
        product_code: '',
        build_num: '',
        box_size: '',
      }
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.form = {
        product_code: '',
        build_num: '',
        box_size: '',
      }
      _this.openStatus = false;
      _this.$emit('finish', {});
    },
    // 获取列表
    toSubmit() {
      const _this = this;
      _this.submitIng = true;
      _this.$api.barcodeBuildGenerate(_this.form)
          .then(res => {
            _this.submitIng = false;
            _this.barCodeList = res.bar_code;
            _this.boxCodeList = res.box_code;
            _this.excelUrl = res.excel_url;
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg);
          })
    },
  },
};
</script>